import { UTILS } from '@aksia/infrastructure';

export enum RatingScaleTypeEnum {
  HedgeFund = 0,
  //LiquidAlternative - deprecated,
  PrivateCredit = 2,
  FundOfFunds,
  PrivateEquity,
  RealAssets,
}
export namespace RatingScaleTypeEnum {
  const replace = [{ key: /([a-z])([A-Z])/g, value: '$1 $2' }];
  export const toOptions = () =>
    UTILS.UI.enumToOptions(RatingScaleTypeEnum, replace);
}

export enum RatingSectionEnum {
  IDD = 0,
  ODD = 1,
}
export namespace RatingSectionEnum {
  export const toOptions = () => UTILS.UI.enumToOptions(RatingSectionEnum);
}
